/* eslint-disable @angular-eslint/component-class-suffix */
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { SelectOption } from '@grupo-constant/next-dtype/types';
import { TranslocoService } from '@ngneat/transloco';
import { DialogsService } from '../dialogs.service';
import { FuseConfirmationService } from '../../../@fuse/services/confirmation/confirmation.service';
import { HttpService } from '../../core/http/http.service';
import { NextMethodsEnum } from '../../core/enums/next-methods.enum';

@Component({
    selector: 'new-masterdata-dialog',
    templateUrl: './new-masterdata-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class NewMasterDataDialog implements OnInit {

    tipologyOptions: SelectOption[];

    tipologyControl: FormControl = new FormControl('', Validators.required);

    validityOptions: SelectOption[];

    validityControl: FormControl = new FormControl('', Validators.required);

    private readonly tipologyClass = 'com.cloudcodice.feature.master.MasterTypology';
    private readonly validityClass = 'com.cloudcodice.feature.master.MasterValidity';

    constructor(
        public dialogRef: MatDialogRef<NewMasterDataDialog>,
        private dialogsService: DialogsService,
        private _fuseConfirmationService: FuseConfirmationService,
        private httpService: HttpService,
        private transloco: TranslocoService,
    ) { }

    ngOnInit() {
        this.httpService.post<{ option: SelectOption[] }>(NextMethodsEnum.retrieveEnumerationType, { enumerationClass: this.tipologyClass })
            .subscribe(reply => this.tipologyOptions = reply.option);
        this.httpService.post<{ option: SelectOption[] }>(NextMethodsEnum.retrieveEnumerationType, { enumerationClass: this.validityClass })
            .subscribe((reply) => {
                this.validityOptions = reply.option.filter(item => item.code !== 'DELETE'); //De momento no habilitamos el de delete
                this.validityControl.setValue(this.validityOptions[0].code);
            });
    }

    getNewInstance() {
        const confirmDialog = this.openConfirmDialog();
        confirmDialog.afterClosed().subscribe((confirm) => {
            if (confirm === 'confirmed') {
                this.tipologyControl.markAsTouched();
                this.validityControl.markAsTouched();
                if (this.tipologyControl.valid && this.validityControl.valid) {
                    this.dialogRef.close({typology: this.tipologyControl.value, validity: this.validityControl.value});
                } else {
                    this.dialogsService.openErrorDialog({
                        message: this.transloco.translate('errorsInForm')
                    });
                }
            }
        });
    }

    closeDialog() {
        this.dialogRef.close();
    }

    private openConfirmDialog() {
        return this._fuseConfirmationService.open({
            title: this.transloco.translate('warning'),
            message: this.transloco.translate('masterNewInstanceMsg'),
            actions: {
                confirm: {
                    label: this.transloco.translate('confirm')
                },
                cancel: {
                    label: this.transloco.translate('cancel')
                }
            }
        });
    }

}
